module.exports = __webpack_public_path__ + "img/CW.5a80f316.svg";